// extracted by mini-css-extract-plugin
export var icon = "_ar-3";
export var subtitle = "_ar-2";
export var title = "_ar-1";
export var value = "_ar-0";